import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import RoundedModal from '../../../../molecules/RoundedModal'
import SydButton from '../../../../commonDesign/Button'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'
import { useSetActiveComponentBlueprintVersion } from '../../../../../api/denali'
import { decipherError } from '../../../../../utils/decipherError'

const SetActiveVersionDialog = React.forwardRef(function SetActiveVersionDialog ({ blueprint, onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, version: null })
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(null)
  const { mutateAsync: setActiveVersion } = useSetActiveComponentBlueprintVersion()

  const close = useCallback(() => {
    setDialogState({ open: false, version: null })
    setError(null)
  }, [])

  useImperativeHandle(ref, () => ({
    open: (version) => setDialogState({ open: true, version })
  }), [])

  const handleConfirm = useCallback(async () => {
    try {
      setError(null)
      setProcessing(true)

      await setActiveVersion({
        blueprintId: blueprint.blueprintId,
        definitionVersionId: dialogState.version.definitionVersionId
      })

      close()
      onComplete()
    } catch (err) {
      setError(decipherError(err))
    } finally {
      setProcessing(false)
    }
  }, [setActiveVersion, blueprint, dialogState, close, onComplete])

  return (
    <RoundedModal
      title='Set Active Version'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p>Set version <strong>{dialogState.version?.definitionVersionId}</strong> as the active version for this blueprint?</p>
            </Grid>
            <Grid item xs={12}>
              <SydModalActions>
                {error ? <div className='__error'>{error}</div> : null}
                <SydButton disabled={processing} variant='ghost' size='md' onClick={close}>
                  Cancel
                </SydButton>
                <SydButton processing={processing} variant='primary' size='md' onClick={handleConfirm}>
                  Confirm
                </SydButton>
              </SydModalActions>
            </Grid>
          </Grid>
        ) : null}
      </div>
    </RoundedModal>
  )
})

SetActiveVersionDialog.propTypes = {
  blueprint: PropTypes.object.isRequired,
  onComplete: PropTypes.func.isRequired
}

export default SetActiveVersionDialog
